/**
 * Shared cell renderers and filter option lists for the warehouse grids
 * (orders, products).
 *
 * Contains:
 * - YesNoCell — inline boolean renderer for grid columns
 * - BOOLEAN_OPTIONS — Yes/No filter option list for boolean columns
 */

import { Box } from '@mui/material';
import { t } from 'i18next';
import React from 'react';

export const BOOLEAN_OPTIONS = [
  { value: 'true', label: t('general.yes', 'Yes') },
  { value: 'false', label: t('general.no', 'No') },
];

export function YesNoCell({ value }) {
  if (value === true) {
    return <Box sx={{ fontSize: '0.75rem', fontWeight: 500, color: 'text.primary' }}>{t('general.yes', 'Yes')}</Box>;
  }
  if (value === false) {
    return <Box sx={{ fontSize: '0.75rem', color: 'text.disabled' }}>{t('general.no', 'No')}</Box>;
  }
  return null;
}
